<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div v-html="getValue(property)">
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowRichTextValueField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    property: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
  },

  computed: {
    getValue () {
      return property => this.object? ((this.object[property] || this.object[property] === false) ? this.object[property] : '-'): '-'
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowRichTextValueField.vue